<div id="showcase">
    <div id="showcaseCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
        <div class="carousel-inner">
            <div class="carousel-item" *ngFor="let slide of slider; let i=index; trackBy: trackByUrl" [class.active]="i === 0">
                <div class="loader-overlay d-flex justify-content-center align-items-center" *ngIf="isLoading[i]">
                    <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                <img
                    [src]="slide.imgUrl"
                    [alt]="slide.title || 'Slider'"
                    class="img-fluid slide-img w-100"
                    [class.loaded]="!isLoading[i]"
                    (load)="hideLoader(i)"
                    (error)="hideLoader(i)">
            </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
    <div class="elementor-shape elementor-shape-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
            <path class="elementor-shape-fill"
                d="M500,97C126.7,96.3,0.8,19.8,0,0v100l1000,0V1C1000,19.4,873.3,97.8,500,97z">
            </path>
        </svg>
    </div>
</div>